module.exports = __webpack_public_path__ + "static/media/coin.cf686fd8.png";